import { Component, EventEmitter, ViewChild, ElementRef, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';

import { peoplefinder } from './animations'
import { AppUpload } from '../../app.upload';
import { UserService } from '../../services/user.service';
import { SocialService } from '../../services/social.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';

import { Account } from '../../models/account';
import { Friend } from '../../models/friend';
import { Post } from '../../models/post';
import { Notification } from '../../models/notification';
import { Interaction } from '../../models/interaction';


@Component({
  selector: 'user-people',
  templateUrl: './people.html',
  providers: [ UserService, SocialService, StoreService ],
  animations: [ peoplefinder ]
})
export class PeopleComponent implements OnInit {

	title: string;
	subtitle: string;
	people: Friend;
	showPeopleFinder: any;
	offset = 0;
	filter = 'everyone';
	
	query = new SearchQuery('');

	constructor(private user: UserService,
				private social: SocialService,
  				private store: StoreService) {}

	/**
	 * Add person as friend
	**/
	addFriend(friendID) {
		Promise.resolve( this.social.friendRequest(friendID) ).then((result) => {
			this.queryPeople();
		});
	}


	/**
	 * Look for people
	**/
	queryPeople(i?) {

		if ( i ) this.query.filter = i;

		var query = ( this.query.filter ) ? this.query.filter : null;
		Promise.resolve( this.social.searchPeople(query, 12, this.offset) ).then((result) => {
			this.people = result;
		});

	}

	prev() {
		this.offset = this.offset - 12;
		this.queryPeople();
	}

	next() {
		this.offset = this.offset + 12;
		this.queryPeople();
	}


	/**
	 * Initalize App
	**/
	ngOnInit() {
		this.queryPeople();
	}

}

export class SearchQuery {
	constructor(
		public filter?: string
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/community/people.component.ts